import { SessionTypeTabItem } from './playerPerformanceUtils';
import { t } from 'utilities/TranslationUtils';

interface SessionTypeTabsProps {
  tabs: SessionTypeTabItem[];
  activeFilterValue: string;
  onSelect: (filterValue: string) => void;
}

const SessionTypeTabs: React.FunctionComponent<SessionTypeTabsProps> = ({ tabs, activeFilterValue, onSelect }) => (
  <div className='pp-tabs' data-test='pp-session-type-tabs'>
    {tabs.map((tab) => (
      <button
        key={tab.filterValue}
        type='button'
        className={`pp-tab${tab.filterValue === activeFilterValue ? ' pp-tab--active' : ''}`}
        onClick={() => onSelect(tab.filterValue)}
        data-test='pp-session-type-tab'
      >
        {t(tab.labelKey)}
      </button>
    ))}
  </div>
);

export default SessionTypeTabs;
